module.exports = __webpack_public_path__ + "img/tajikistan.f7ee98a1.svg";